export const stripShelfTopClass = 'top-1/2' as const

export const stripSlideSmall = {
  frameClassName: 'translate-y-[0.59375rem]',
  slideClassName: 'basis-[64.8%] sm:basis-[43.2%] lg:basis-[27.99%]',
  width: 640,
  height: 360,
} as const

export const stripSlideBig = {
  frameClassName: 'mt-3',
  slideClassName: 'basis-[77.4%] sm:basis-[52.2%] lg:basis-[33.66%]',
  width: 640,
  height: 360,
} as const

export const stripZClasses = ['z-10', 'z-30', 'z-20', 'z-30'] as const

export const stripCarouselControlClassName =
  'top-1/2 z-50 size-10 -translate-y-1/2 rounded-full border-[1.5px] border-white/95 bg-black/50 text-white hover:bg-black/60 hover:text-white disabled:opacity-40'

export const stripCarouselSlideClassName =
  '-ml-[1.2375rem] pl-0 sm:-ml-[1.98rem] lg:-ml-[2.41875rem]'

export const stripCarouselTrackClassName =
  'ml-0 items-center pl-[1.2375rem] pr-12 sm:pl-[1.98rem] lg:pl-[2.41875rem] lg:pr-16'

export type ImageGalleryStripSlide = {
  id: string
  image: string
  imageAlt: string
  locationLabel?: string
}

export type ResolvedImageGalleryStripSlide = ImageGalleryStripSlide & {
  frameClassName: string
  slideClassName: string
  width: number
  height: number
  zClassName: string
}

export function buildStripSlidePresets(
  slides: ImageGalleryStripSlide[],
): ResolvedImageGalleryStripSlide[] {
  return slides.map((slide, index) => ({
    ...slide,
    ...(index % 2 === 0 ? stripSlideSmall : stripSlideBig),
    zClassName: stripZClasses[index % stripZClasses.length] ?? 'z-10',
  }))
}
